<template>
  <main v-if="!detail" class="main_inner flex-grow-1 loading" />
  <main v-else class="main_inner flex-grow-1">
    <div class="insurance_info_area d-grid">
      <div class="bonus_offer_list d-block list-unstyled mb-0">
        <div>
          <!-- 連結網址要更換 -->
          <a href="#" class="card bonus_offer_card border-0 p-0">
            <div class="picture">
              <picture>
                <source
                  media="(min-width: 992px)"
                  :src="detail.image_small"
                >
                <!-- 手機版圖片 -->
                <img
                  class="img d-block d-md-none"
                  :src="detail.image_mobile"
                  alt=""
                >
                <!-- 電腦版圖片 -->
                <img
                  class="img d-none d-md-block"
                  :src="detail.image_small"
                  alt=""
                >
              </picture>
            </div>
            <div class="inverted-border-radius">
              <div class="info">
                <div class="text">
                  <p>Time: {{ detail.start_at | dateFormat }}~{{ detail.end_at | dateFormat }}</p>
                  <p>Condition: {{ detail.vip_level_text.join(', ') }}</p>
                </div>
                <div :class="['btn', disabledClass(detail.status)]" :disabled="actionLoading" @click="clickAction(detail)">
                  <p>
                    {{ detail.status_text }}
                    <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
                  </p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <img class="w-100 d-block d-md-none" :src="detail.image_mobile_big" alt="">
      <img class="w-100 d-none d-md-block" :src="detail.image_big" alt="">
    </div>
  </main>
</template>

<script>
import { getEventDetail, joinEvent, receive } from '@/api/event'
import { showNotice } from '@/utils/tool'
import { logout } from '@/utils/user'

export default {
  data() {
    return {
      detail: false,
      actionLoading: false
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      getEventDetail(this.$route.params.event_id).then(response => {
        this.detail = response.data.data
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    getVipStr() {
      if (!this.detail) return
      let str = ''
      this.detail.vip_level_text.forEach(function(value) {
        str += value + ','
      })
      return str.slice(0, -1)
    },
    getRiskStr() {
      if (!this.detail) return
      let str = ''
      this.detail.risk_level_text.forEach(function(value) {
        str += value + ','
      })
      return str.slice(0, -1)
    },
    disabledClass(status) {
      return [0, 1, 3, 5].indexOf(status) === -1 ? 'btn_over' : ''
    },
    clickAction(item) {
      if (this.actionLoading) {
        return
      }
      if (item.status === 0) {
        logout(this.$t('Bao.please_login_for_function'))
      } else if (item.status === 3) {
        this.actionLoading = true
        joinEvent(item.id).then(response => {
          showNotice(response.data.msg)
          this.query()
        }).catch((error) => {
          showNotice(error.response.data.msg)
        }).finally((e) => {
          this.actionLoading = false
        })
      } else if (item.status === 5) {
        this.actionLoading = true
        receive(item.event_member_id).then(response => {
          showNotice(response.data.msg)
          this.query()
        }).catch((error) => {
          showNotice(error.response.data.msg)
        }).finally((e) => {
          this.actionLoading = false
        })
      }
    }
  }
}
</script>
